$(document).ready(function(){
  var flk_btn = 0;
  $( ".flk_zoom" ).each(function( index ) {
    flk_btn++;
    $(this).attr("data-id","flk_gly-" + flk_btn);
  });
});
$(document).ready(function(){
  var flk_zim = 0;
  $( ".flk_modal" ).each(function( index ) {
    flk_zim++;
    $(this).attr("id","flk_gly-" + flk_zim);
  });
});

$('.flk_zoom').on('click', function(){
  flk_id = $(this).attr('data-id');
  $( ".flk_modal" ).each(function() {
    $('.flk_modal').removeClass('active');
  });
  $('#flk_modal_wrapper').addClass('active');
  $('#' + flk_id).addClass('active');
});
$('#flk_modal_wrapper').on('click', function(){
  flk_id = $(this).attr('data-id');
  $( ".flk_modal" ).each(function() {
    $('.flk_modal').removeClass('active');
  });
  $('#flk_modal_wrapper').removeClass('active');
});

/*function dragging(event) {
  console.log("drag Start");
  $(this).addClass('zoom_disable');
  });
}
function dragEnd(event) {
  console.log("drag End");
  $(this).removeClass('zoom_disable');
  });
}*/